import { render } from "./MobileAppEntry.vue?vue&type=template&id=70ab4b4c"
import script from "./MobileAppEntry.vue?vue&type=script&lang=js"
export * from "./MobileAppEntry.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__